<div mat-dialog-title class="fx-layout-row">
  <div class="fx-layout-row fx-flex fx-align--x-center fx-align--space-between-x">
    <h2>
      {{ data.title }}
    </h2>
    @if (data.closeMethod == 'x') {
      <button mat-icon-button mat-dialog-close tabindex="-1">
        <mat-icon svgIcon="x"></mat-icon>
      </button>
    }
  </div>
</div>

<mat-dialog-content [innerHtml]="sanitize(data.message)" [ngClass]="{'no-actions': data.closeMethod !== 'button' && !data.yesButtonText}">

</mat-dialog-content>

@if (data.closeMethod == 'button' || data.yesButtonText) {
  <mat-dialog-actions [ngClass]="{'single-button': data.yesButtonText && !data.noButtonText}"
    class="fx-layout-row fx-align--space-between-x">
    @if (data.yesVerifierText) {
      <mat-checkbox [(ngModel)]="yesVerified">
        {{ data.yesVerifierText }}
      </mat-checkbox>
    }
    <button mat-flat-button [color]="data?.primaryButtonColor ? data.primaryButtonColor : 'primary'" [mat-dialog-close]="!data.yesVerifierText || yesVerified">
      {{ data.yesButtonText }}
    </button>
    @if (data.noButtonText) {
      <button mat-flat-button [color]="data?.secondaryButtonColor ? data.secondaryButtonColor : 'secondary'" [mat-dialog-close]="false">
        {{ data.noButtonText }}
      </button>
    }
  </mat-dialog-actions>
}
